export default __webpack_public_path__ + "static/media/balmain_3.8d44d115.jpg";